import { PayItemsSummary } from '../../../cimsPage/instances/payItems'
import { BasicPermissionItem } from '../../PermissionItem'

const summary = 'Pay Item Summary'

export const ViewPayItemSummary = new BasicPermissionItem({
  id: '1aba74bb-7782-42da-a777-3499c0dd3bde',
  action: 'view the Pay Item Summary',
  allowMixedCase: true,
  page: PayItemsSummary,
  name: `View ${summary}`,
  crud: 'View',
})
export const EditPayItemSummary = new BasicPermissionItem({
  id: '3a741de0-71c9-4836-90ba-ff9bb56d04d2',
  action: 'edit the Pay Item Summary',
  allowMixedCase: true,
  page: PayItemsSummary,
  name: `Edit ${summary}`,
  crud: 'Edit',
})

export type PayItemsSummaryPermission =
  | typeof ViewPayItemSummary
  | typeof EditPayItemSummary
